import type { UserItemProps } from '@pages/Users/context/types'
import type { UserDataFormProps } from './types'
import type { UserDataProps } from '@pages/Users/context/types'

export const setInitialValues = (data: UserItemProps | null, usersData: UserDataProps | null) => {
  if (!data) return null

  const profile = usersData?.availableFilters?.profiles.find(
    (item) => item.profileDescription === data?.profileDescription
  )

  const formData: UserDataFormProps = {
    userName: data?.name || '',
    userCode: data?.code?.toString() || '',
    email: data?.email || '',
    login: data?.accessCode || '',
    role: data?.position || '',
    profileDescription: profile?.id || '',
    isAdmin: data?.isAdmin || false
  }

  return formData
}
